const getBlob = (() => {
  let memo = new Map()

  return (byteLength) => {
    let memoVal = memo.get(byteLength)

    if (typeof memoVal !== 'undefined') return memoVal

    let buffer = new ArrayBuffer(byteLength);
    const view = new Uint16Array(buffer);
    view.fill(42);
    const blob = new Blob([view]);

    memo.set(byteLength, blob);

    return blob
  }
})()


export const mkXhrImpl =
  ({ url, byteLength, onProgress, onLoad, onError, onLoadStart }) =>
    () => {
      const xhr = new XMLHttpRequest();

      xhr.open("POST", url, true);

      xhr.upload.onprogress = (event) => {
        onProgress(event)();
      };

      /**
       * Here onload is used, and not upload.onloadend. This is because in some circumstances
       * (see ticket here https://gitlab.com/anw.net/vodafone/html-speedtest/-/issues/272, 
       *  or here https://tresor.it/p#0027r8lh1jehp3v1s4zso5nl/Products/network%20intelligence%20quality%20suite/development/gitlab%20ticket%20272%2Epdf) 
       * the upload.onloadend event is called way too early, and causes unreasonably high speeds.
       */

      xhr.onload = (_) => {
        if (xhr.status >= 400) {
          onError(`XHR upload got unsuccessful HTTP Status: ${xhr.status}`)();
        } else {
          onLoad();
        }
      };

      xhr.upload.onloadstart = (_) => {
        onLoadStart();
      };

      xhr.upload.onerror = (event) => {
        onError(`XHR OnError`)();
      };

      /*
        Safari calls the ontimeout if the connection could not be established with a given host after 
        somtheing like 90 seconds. In the same situation, Chrome calls the onerror callback.
      */
      xhr.upload.ontimeout = (event) => {
        onError(`XHR OnTimeout`)();
      };

      /*
        xhr.upload.onabort is intentionally unhandled, because we don't want to
        emit events after the streamer is cancelled.
      */

      const blob = getBlob(byteLength)

      /*
        xhr.timeout should not be set. The timeout causes the XHR to fail if the response did not 
        complete before timeout, where completion means the response was completely loaded.
        In our case, the timeout will break a working upload speedtest, because the upload 
        process can take a long time, much longer than timeout.
      */

      xhr.send(blob);

      return {
        abort: () => {
          xhr.abort()
        },
      };
    };
